import input from './SmartInputContainer'
import InputWrap from './InputWrap';

export default input

export { InputWrap };